export default __webpack_public_path__ + "assets/images/94a71d95af3eef16f5edacd1e08fabd7.png";